import { render, staticRenderFns } from "./MypageMailChangeCompletePage.vue?vue&type=template&id=2aa29454"
import script from "./MypageMailChangeCompletePage.vue?vue&type=script&lang=ts"
export * from "./MypageMailChangeCompletePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports